/**
 * Binance market stream URLs (see Binance WS docs):
 * - Spot raw: wss://stream.binance.com:9443/ws/<stream>
 * - USD-M futures kline: wss://fstream.binance.com/market/ws/<stream>
 * SUBSCRIBE ack {"result":null,"id":1} means success, not an error.
 */
function buildStreamName(symbol, interval) {
	return `${String(symbol).toLowerCase()}@kline_${interval}`;
}

function buildWsUrl(symbol, interval, isSpot) {
	const stream = buildStreamName(symbol, interval);
	if (isSpot) {
		return `wss://stream.binance.com:9443/ws/${stream}`;
	}
	return `wss://fstream.binance.com/market/ws/${stream}`;
}

function unwrapStreamPayload(data) {
	if (data && data.data && typeof data.data === "object") {
		return data.data;
	}
	return data;
}

export function startBinanceStream(symbol, interval, onRealtimeCallback, isSpot = false) {
	if (!symbol || !interval) {
		console.warn("[Binance WS] missing symbol or interval", { symbol, interval });
		return null;
	}

	const wsUrl = buildWsUrl(symbol, interval, isSpot);
	const socket = new WebSocket(wsUrl);

	socket.addEventListener("open", () => {
		console.log("[Binance WS] connected", wsUrl);
	});

	socket.addEventListener("message", (event) => {
		let data;
		try {
			data = JSON.parse(event.data);
		} catch {
			return;
		}

		// Subscription ack when using SUBSCRIBE API (we use raw stream URL instead)
		if (data.result === null && data.id != null && !data.e && !data.stream) {
			return;
		}

		const payload = unwrapStreamPayload(data);
		if (payload?.e !== "kline" || !payload.k) {
			return;
		}

		const k = payload.k;
		const bar = {
			time: k.t,
			open: parseFloat(k.o),
			high: parseFloat(k.h),
			low: parseFloat(k.l),
			close: parseFloat(k.c),
			volume: parseFloat(k.v),
		};

		if (k.x) {
			console.log(
				`📊 ${symbol.toUpperCase()} - CLOSED - Time: ${new Date(k.t)}, Open: ${k.o}, Close: ${k.c}, Volume: ${k.v}`,
			);
		}

		try {
			onRealtimeCallback(bar);
		} catch (error) {
			console.error("❌ Error in onRealtimeCallback:", error);
		}
	});

	socket.addEventListener("error", (error) => {
		console.error("❌ WebSocket error:", wsUrl, error);
	});

	socket.addEventListener("close", (event) => {
		console.warn("❗ WebSocket closed", wsUrl, event.code, event.reason);
	});

	return socket;
}
